import kkcRequest, { Options } from '@/../../common/src/utils/requests/request';
import { ProductType } from '@/AppGlobal';
import {
  ClCheckInfoV2,
  ClCreditLimit,
  ClIncreaseCreditLimitDto,
  CreditApplyLimitDto,
  IncreaseCreditLimit,
  PaymentDTO,
  RemainPrincipalDto,
} from '@/interface/CL/clCredit';
import { CouponType } from '@/interface/KKC/coupon';
import {
  BankCardType,
  ContractInfoType,
  LoanEntity,
  repaymentPlanList,
} from '@/interface/KKC/withdrawal';
import type { AppliedProduction } from '@/interface/pub';
import { clRequest as request } from '@/utils/request';
import { getGlobalUserInfo } from '@/utils/singletonUtils';
import VhkStore from '@/vhkstore';
import { setCreditApply } from '@/vhkstore/slices/CL/clCredit';
import { creditApply } from './subpages/CreditProcess/interface';

export const introCaculator = (fillInItems: any) =>
  request.post<{
    max: number;
    min: number;
  }>('credit/nl/product/loan/calculator', fillInItems);

export const queryClCreditInfo = (options?: Options, params?: creditApply) =>
  request
    .post<creditApply>('credit/clCredit/selectNode', params, options)
    .then((res) => {
      VhkStore.dispatch(setCreditApply({ creditApply: res }));
      return res;
    })
    .catch((err) => {
      console.log('queryClCreditInfo err', err);
      return Promise.reject(err);
    });

export const executeFlow = (params?: creditApply, options?: Options) =>
  request
    .post<creditApply>('credit/clCredit/executeFlow', params, { loading: true, ...options })
    .then((res) => {
      VhkStore.dispatch(setCreditApply({ creditApply: res }));
      return res;
    })
    .catch((err) => {
      console.log('executeFlow err', err);
      return Promise.reject(err);
    });

export const queryClCreditLimit = (productCode?: string) =>
  kkcRequest.post<ClCreditLimit>(
    '/credit/clCredit/clLimit',
    null,
    {},
    { productCode: productCode || 'CL' }
  );

// 查询CL 放款的状态
export const queryClLoanInfo = (options?: Options) =>
  request.post<PaymentDTO>('credit/clPay/payCheck', null, options);

export const clRepaymentPlan = (params: PaymentDTO, options?: Options) =>
  request.post<PaymentDTO>('/credit/clPay/repaymentPlan', params, { ...options, hideError: true });

export const clRepaymentPlanPreApprove = (params: PaymentDTO) =>
  request.post<PaymentDTO>('/credit/clPay/repaymentPlanPreApprove', params);

export const querySelectedBank = () => request.post<PaymentDTO>('/credit/clPay/selectPayBank');

export const queryIsNeedOtp = () =>
  request.post(
    '/credit/clPay/isNeedOtp',
    {},
    {
      hideError: true,
      loading: true,
    }
  );

// 提现流程的触发
export const clPayExecuteFlow = (
  params: PaymentDTO & { productLabel?: string },
  loading = true,
  hideError = false
) => request.post('/credit/clPay/executeFlow', params, { loading, hideError });

// h5 提现流程的触发
export const clPayH5ExecuteFlow = (params: { request: string }, loading = true) =>
  request.post('/credit/clPay/h5/executeFlow', params, { loading });

// 查询订单情况
export const queryClOrderInfo = (params: PaymentDTO) =>
  request.post<PaymentDTO>('/credit/clPay/getOrderInfo', params);
// 查询还款计划
export const repaymentPlan = (params: {
  loanMaturity: number;
  loanAmt: number;
  paymentBankFlows: BankCardType[];
}) => request.post<repaymentPlanList>('credit/clPay/repaymentPlan', params);

// 提额-查询职业
export const selectLimitInfo = () =>
  request.post<CreditApplyLimitDto>('credit/limit/selectLimitInfo');

// 提额-查询状态
export const selectLimitState = () =>
  request.post<IncreaseCreditLimit>('credit/limit/selectLimitState', {}, { hideError: true });

// 查询是否是新提额申请流程
export const queryWeatherNewAppeal = () =>
  request.post<ClCheckInfoV2>('credit/limit/clCheckInfo/v2', {}, { hideError: true });

// 查询提额记录
export const selectLimitRecord = (productCode?: string) =>
  kkcRequest.post<Array<ClIncreaseCreditLimitDto>>(
    'credit/limit/selectLimitRecord',
    null,
    {},
    { productCode: productCode || 'CL' }
  );

// 提升额度申请
export const increaseLimitOps = (params: any) =>
  request.post<creditApply>('credit/limit/increaseLimitOps', params);

// 上傳文件提交
export const uploadCreditFile = (params: any) =>
  request.post<creditApply>('credit/clCredit/uploadCreditFile', params);

// 下载合同pdf
export const downloadContactPdf = (params: LoanEntity) =>
  request.post<ContractInfoType>('/credit/pay/download', params, { loading: true });

export const queryAppliedProduction = (option?: Options) =>
  request.post<AppliedProduction>('/credit/clCredit/isApply', {}, { loading: true, ...option });

export const queryblackProduction = async (option?: Options) =>
  request.get<boolean>(
    `/credit/bill/label-face/${(await getGlobalUserInfo()).userId}`,
    {},
    { loading: true, ...option }
  );

export const isClCanShowInvitationCode = () =>
  request.post<{
    isShow: boolean;
  }>('/credit/apply/isCanShowInvitationCode');

export const checkHasSlaPassMuster = () =>
  request.post<boolean>('/credit/clCredit/checkHasSlaPassMuster');

export const queryReduceCouponVal = () =>
  request.post<{
    param1: string;
  }>('/credit/coupon/selectLastMetaInfo', { couponType: CouponType.ReduceInterestCoupon });

// CL 預先批核 check
export const preApproveSureInfoCheck = () =>
  request.post('credit/clCredit/preApproveSureInfoCheck');

export const queryIsFirstLoan = (productType: ProductType) =>
  request.get<boolean>(`/credit/pay/getIsFirstLoan?productCode=${productType}`);

// 查询剩余在贷本金
export const queryRemainPrincipal = (params: { productCode: ProductType }) =>
  request.post<RemainPrincipalDto>(`/credit/query/remainPrincipal`, params);
